import React from "react";

export const SCHEDULE_NAME_COL_DEFAULT = 160;
export const SCHEDULE_NAME_COL_MIN = 120;
export const SCHEDULE_NAME_COL_MAX = 420;

export function scheduleBuilderTableColGroup(weekDates, nameColPx = SCHEDULE_NAME_COL_DEFAULT) {
  return (
    <colgroup>
      <col style={{ width: nameColPx, minWidth: nameColPx, maxWidth: nameColPx }} />
      {weekDates.map((_, i) => <col key={i} />)}
    </colgroup>
  );
}

export function scheduleBuilderNameColWidthFromStorage() {
  try {
    const saved = localStorage.getItem("pg_schedule_name_col_width");
    const parsed = saved ? parseInt(saved, 10) : null;
    if (parsed && parsed >= SCHEDULE_NAME_COL_MIN && parsed <= SCHEDULE_NAME_COL_MAX) return parsed;
  } catch { /* ignore */ }
  return SCHEDULE_NAME_COL_DEFAULT;
}

export function formatPeopleCostRevenueEuros(amount) {
  const n = Math.round(Number(amount));
  return `€${n.toLocaleString("en-US")}`;
}

export function peopleCostRevenueHintText(basis, amount, lang) {
  if (basis == null || amount == null || !Number.isFinite(Number(amount))) return null;
  const euros = formatPeopleCostRevenueEuros(amount);
  if (basis === "actuals_last_year") {
    return lang === "gr"
      ? `βάση ${euros} πέρυσι`
      : `based on ${euros} last year actuals`;
  }
  if (basis === "actuals") {
    return lang === "gr"
      ? `βάση ${euros} πραγματικά`
      : `based on ${euros} actuals`;
  }
  return lang === "gr"
    ? `βάση ${euros} πρόβλεψη`
    : `based on ${euros} forecast`;
}

export function dayHeaderRevenueBasisLabel(basis, lang) {
  if (!basis) return null;
  if (basis === "actuals" || basis === "actuals_last_year") {
    return lang === "gr" ? "πραγματικά" : "actuals";
  }
  if (basis === "forecast") {
    return lang === "gr" ? "πρόβλεψη" : "forecast";
  }
  return null;
}

